import { END_POINTS } from "../constants"
import ProjectListRes from "../models/ProjectListModel"
import { API } from "../services"
import { mergeRowsColumns } from "../utils"
var api = API.getInstance()
 
export const getExcessActiveHours = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})

export const getFixedBid = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})
export const getBillable = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})
export const getBillableTM = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})
export const getInternal = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})
export const getTraining = async (request) => new Promise((resolve, reject) => {
    api.onPostApi(END_POINTS.getList, request).then((response) => {
       const res = response.json.data
       const data = mergeRowsColumns(res)
       let responceModel = new ProjectListRes().initWithRes(data)        
       resolve(responceModel)
    }).catch((error) => {
        reject(error)
    })
})
